<template>
  <div v-loading="loading" class="chartsData">
    <!-- 轻量化监控统计图 -->
    <div ref="lightChart" class="left"></div>
    <div class="right">
      <div>
        <div>
          <span>总文件数:</span>
          <span class="num">{{ detailData.totalFileNum }}</span>
          <span>个</span>
        </div>
        <div>
          <span class="point point-orange"></span>
          <span>平均每日上传文件数:</span>
          <span class="num num-orange">{{ detailData.avgFileNum }}</span>
          <span>个</span>
        </div>
        <div>
          <span class="point point-green"></span>
          <span>轻量化成功数:</span>
          <span class="num num-green">{{ detailData.successNum }}</span>
          <span>个</span>
        </div>
        <div>
          <span class="point point-pink"></span>
          <span>轻量化失败数:</span>
          <span class="num num-pink">{{ detailData.failNum }}</span>
          <span>个</span>
        </div>
      </div>
      <div>
        <div>
          <span class="point point-green"></span>
          <span>平均轻量化时长:</span>
          <span class="num num-green">{{ detailData.avgConvertTime }}</span>
          <span></span>
        </div>
        <div>
          <span class="point point-orange"></span>
          <span>平均排队时长:</span>
          <span class="num num-orange">{{ detailData.avgLineUpTime }}</span>
          <span></span>
        </div>
        <div>
          <span class="point point-blue"></span>
          <span>转换中:</span>
          <span class="num num-blue">{{ detailData.convertingNum }}</span>
          <span>个</span>
        </div>
        <div>
          <span class="point point-blue"></span>
          <span>排队中:</span>
          <span class="num num-blue">{{ detailData.waitingNum }}</span>
          <span>个</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import lightService from "@/CommonDP/service/light-service";
import * as echarts from 'echarts';
let lightChart; // 轻量化监控统计图

export default {
  components: {},
  props: {
    searchForm: {
      type: Object,
      default: () => ({})
    } // 筛选表单
  },
  data() {
    return {
      loading: false,
      chartsData: [],
      detailData: {}
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.init();
    window.addEventListener("resize", this.chartsResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.chartsResize);
  },
  methods: {
    // 状态名称
    statusName(status) {
      let name = "";
      switch (status) {
        case 30:
          name = "排队中";
          break;
        case 31:
          name = "转换中";
          break;
        case 41:
          name = "成功";
          break;
        case 42:
          name = "失败";
          break;
      }
      return name;
    },
    // 初始化
    init() {
      lightChart = echarts.init(this.$refs.lightChart, null, { renderer: "svg" }); // 问题专业分布图
      this.search();
    },
    // 获得数据
    async getData() {
      this.loading = true;
      try {
        const params = {
          ...this.searchForm
        };
        const { data } = await lightService.getCount(params);
        this.chartsData = data || [];
        const { data: data2 } = await lightService.getCountDetail(params);
        this.detailData = data2 || {};
      } finally {
        this.loading = false;
      }
    },
    // 查询
    async search() {
      await this.getData();
      this.setOption();
    },
    // 加载数据
    setOption() {
      const data =
        this.chartsData.map((item) => {
          return {
            value: item.count,
            name: this.statusName(item.status)
          };
        }) || [];
      let allNum = 0;
      data.forEach(({ value }) => {
        allNum += value;
      });
      const legendData = data.map((item) => item.name);
      // 指定图表的配置项和数据
      const option = {
        color: ["#3791fb", "#56ca77", "#fa5f87", "#f5ca44"],
        // 图例
        legend: {
          orient: "vertical",
          left: "75%",
          top: 20,
          data: legendData,
          formatter(name) {
            let value = 0;
            let rate = 0;
            data.forEach((item, index) => {
              if (item.name == name) {
                value = item.value;
                rate = ((item.value / allNum) * 100).toFixed(2);
              }
            });
            if (allNum == 0) return `${name} 0%`;
            else return `${name} ${rate}%`;
          }
        },
        // 列表
        series: [
          {
            type: "pie",
            radius: ["58%", "88%"],
            center: ["35%", "50%"],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            data: data
          }
        ],
        // 提示
        tooltip: {
          trigger: "item",
          padding: [10, 15, 10, 10],
          extraCssText: "line-height: 22px", // 行高
          formatter(e) {
            const rate = ((allNum > 0 ? e.value / allNum : 0) * 100).toFixed(2) + "%";
            return `${e.marker + " " + e.name}<br>&nbsp;&nbsp;&nbsp;&nbsp;数量：${e.value}<br>&nbsp;&nbsp;&nbsp;&nbsp;占比：${rate}`;
          }
        }
      };
      // 使用刚指定的配置项和数据显示图表。
      lightChart.setOption(option);
    },

    // 缩放重置大小
    chartsResize() {
      lightChart.resize();
      this.setOption();
    }
  }
};
</script>

<style lang="scss" scoped>
.chartsData {
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: space-evenly;
  .left {
    width: 600px;
    height: 300px;
  }
  .right {
    width: max-content;
    white-space: nowrap;
    padding-top: 10px;
  }
}

.right {
  display: flex;
  justify-content: center;
  & > div {
    width: max-content;
    padding: 0 40px;
    text-align: right;
    span {
      font-size: 14px;
      vertical-align: middle;
    }
    line-height: 44px;
    .num {
      font-size: 20px;
      font-weight: 600;
      display: inline-block;
      margin-left: 15px;
      margin-right: 5px;
    }
    .num-orange {
      color: #fa8d19;
    }
    .num-green {
      color: #64d7b9;
    }
    .num-pink {
      color: #fa5f87;
    }
    .num-blue {
      color: var(--theme-color);
    }
    .point {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 7px;
    }
    .point-orange {
      background-color: #fdc68c;
    }
    .point-green {
      background-color: #b2ebdc;
    }
    .point-pink {
      background-color: #fdafc3;
    }
    .point-blue {
      background-color: #aac3f8;
    }
  }
}
</style>
